// External pakcages
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

// Components
import { Label } from 'components/Forms';
import { Icon } from 'components/Icons';
import { Option } from 'components/Select';
import {
  SelectMultipleField,
  type SelectMultipleFieldProps,
} from 'components/SelectMultiple';

// Hooks
import { useGetAllMedia } from 'api/media';

// Types
import { Media } from '../../../server/src/types/media.types';

// Utils
import { twMerge } from 'tailwind-merge';

export const AudioSelectField: React.FC<
  Omit<SelectMultipleFieldProps<any>, 'children'> & {
    containerClassName?: string;
  }
> = ({ containerClassName, ...props }) => {
  const { data: media } = useGetAllMedia('audio');
  const { control, setValue } = useFormContext();

  const fieldName = props.name ?? '';
  const selectedIds = useWatch({ control, name: fieldName });
  const selectedAudio =
    media?.filter((item: Media) =>
      Array.isArray(selectedIds) ? selectedIds.includes(item.id) : false
    ) || [];

  return (
    <div className={twMerge(containerClassName)}>
      <SelectMultipleField items={media} {...props} isDisabled={!media?.length}>
        {media.map((item: Media) => (
          <Option key={item.id} id={item.id}>
            <div className="flex items-center gap-2">
              <audio controls>
                <source src={item.url} type={item.mimeType} />
                Your browser does not support the audio element.
              </audio>
              <span>{item.originalFileName || item.fileName || item.id}</span>
            </div>
          </Option>
        ))}
      </SelectMultipleField>
      {selectedAudio.length > 0 && (
        <div className="px-4 mt-2 md:px-8">
          <Label className="text-sm">Odabrani audio</Label>
          <div className="space-y-2">
            {selectedAudio.map((item: Media) => (
              <div key={item.id} className="flex items-center gap-2">
                <audio controls>
                  <source src={item.url} type={item.mimeType} />
                  Your browser does not support the audio element.
                </audio>
                <span className="text-sm text-gray-600">
                  {item.originalFileName || item.fileName || item.id}
                </span>
                <button
                  type="button"
                  className="flex cursor-pointer items-center justify-center text-red-500"
                  onClick={() => {
                    if (Array.isArray(selectedIds)) {
                      setValue(
                        fieldName,
                        selectedIds.filter((id: string) => id !== item.id)
                      );
                    }
                  }}
                  aria-label="Ukloni audio"
                >
                  <Icon name="x" className="size-8" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
